import { SliderInput } from '@naker/design/Inputs/slider';
import { ImageAssetButton } from '@naker/design/Pickers/assetPicker';
import { InputGroupSwitch } from '@naker/design/Layers/actionPanel';

import { spy } from './service/session';
import { Particle, particleInterface } from '../viewer/particle';
import { BackUndo } from './service/undo';

/*
  +------------------------------------------------------------------------+
  | GEOMETRY MANAGER                                                    |
  +------------------------------------------------------------------------+
*/

export class geometrySettingsClass extends InputGroupSwitch {

    particle: Particle;

    constructor(undo: BackUndo, particle: Particle) {
        super('Particles', undo);

        this.particle = particle;
        this.addGeometryInput();
        this.checkInput(particle.getOptions());

        undo.on("change", (change) => {
            if (change.particle) this.checkInput(change.particle);
        });
    }

    textureInput: ImageAssetButton;
    numberInput: SliderInput;
    sizeStartInput: SliderInput;
    lifeInput: SliderInput;
    sensitivityInput: SliderInput;

    addGeometryInput() {
        this.textureInput = this.addImageAssetInput('Particle', { type: 'image', url: undefined }, (texture: string) => {
            spy.track('Particle Change');
            this.particle.setTexture(texture);
        });
        this.textureInput.hideLabel();

        this.numberInput = this.addSlider('Number', { value: 1, min: 0, max: this.particle.maximumParticle, curve: 'logarithmic', step: 1 }, (value) => {
            this.particle.setNumber(value);
            this.particle.checkParticlePower(this.particle.power);
        });

        this.sizeStartInput = this.addSlider('Size', { value: 1, min: 0, max: 2, step: 0.01 }, (value) => {
            this.particle.setSizeStart(value);
            this.particle.setSizeEnd(value * 2);
        });
    }

    resetInput(particleoptions: particleInterface) {
        this.textureInput.setValue(particleoptions.texture);
        this.numberInput.setValue(particleoptions.number);
        this.sizeStartInput.setValue(particleoptions.sizeStart);
    }

    checkInput(particleoptions: particleInterface) {
        if (particleoptions.texture !== undefined) this.textureInput.setValue(particleoptions.texture);
        if (particleoptions.number !== undefined) this.numberInput.setValue(particleoptions.number);
        if (particleoptions.sizeStart !== undefined) this.sizeStartInput.setValue(particleoptions.sizeStart);
    }
}